import React, {Suspense} from 'react';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';
const Ivw = React.lazy(() => import('app/components/lazyLoadWrapper/ivw/IvwComponent'));

const selectPartner = createSelector(
  state => state.partner,
  partner => {
    const ivwValues = Object.values(partner.ivw).filter(value => value);
    return {partner, hasIvwValues: ivwValues.length};
  }
);

const IvwLoader = () => {
  const {partner, hasIvwValues} = useSelector(selectPartner);
  return hasIvwValues ? (
    <Suspense fallback={null}>
      <Ivw partner={partner} />
    </Suspense>
  ) : null;
};

export default IvwLoader;
